import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api';
import Header from '../Components/Header';

const SignupEmail = () => {
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [agreedToTerms, setAgreedToTerms] = useState(false);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        password2: ''
    });

    const [errors, setErrors] = useState({
        name: '',
        email: '',
        password: '',
        password2: ''
    });

    const [enabledFields, setEnabledFields] = useState({
        name: true,
        email: false,
        password: false,
        password2: false
    });

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validatePassword = (password) => {
        const hasNumber = /\d/.test(password);
        const hasLetter = /[a-zA-Z]/.test(password);
        const hasSpecial = /[^A-Za-z\d]/.test(password);
        const isValidLength = password.length >= 8 && password.length <= 20;
        return hasNumber && hasLetter && hasSpecial && isValidLength;
    };

    useEffect(() => {
        if (formData.name.length > 0 && formData.name.length <= 50) {
            setEnabledFields(prev => ({ ...prev, email: true }));
        } else {
            setEnabledFields(prev => ({
                ...prev,
                email: false,
                password: false,
                password2: false
            }));
        }

        if (enabledFields.email && validateEmail(formData.email)) {
            setEnabledFields(prev => ({ ...prev, password: true }));
        } else {
            setEnabledFields(prev => ({
                ...prev,
                password: false,
                password2: false
            }));
        }

        if (enabledFields.password && validatePassword(formData.password)) {
            setEnabledFields(prev => ({ ...prev, password2: true }));
        } else {
            setEnabledFields(prev => ({
                ...prev,
                password2: false
            }));
        }
    }, [formData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        validateField(name, value);
    };

    const validateField = (fieldName, value) => {
        let newErrors = { ...errors };

        switch (fieldName) {
            case 'name':
                if (value.length > 50) {
                    newErrors.name = '이름은 최대 50자까지 입력 가능합니다.';
                } else if (value.length === 0) {
                    newErrors.name = '이름을 입력해주세요.';
                } else {
                    newErrors.name = '';
                }
                break;

            case 'email':
                if (!validateEmail(value)) {
                    newErrors.email = '이메일 형태로 입력해주세요';
                } else {
                    newErrors.email = '';
                }
                break;

            case 'password':
                if (!validatePassword(value)) {
                    newErrors.password = '영문, 숫자, 특수문자를 조합한 8~20자로 입력하세요.';
                } else {
                    newErrors.password = '';
                }
                break;

            case 'password2':
                if (value !== formData.password) {
                    newErrors.password2 = '비밀번호가 일치하지 않습니다.';
                } else {
                    newErrors.password2 = '';
                }
                break;

            default:
                break;
        }

        setErrors(newErrors);
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const response = await api.post('users/signup/', formData);
            navigate('/verify-email', {
                state: { email: formData.email }
            });

        } catch (error) {
            if (error.response) {
                const data = error.response.data;
                const msg = data.message
                    || Object.values(data).flat().join('\n')
                    || '회원가입에 실패했습니다.';
                alert(msg);
            } else if (error.request) {
                console.error('서버 응답 없음:', error.request);
                alert('서버와의 통신에 실패했습니다.');
            } else {
                console.error('요청 오류', error.message);
                alert('요청 중 오류가 발생했습니다.');
            }
        } finally {
            setIsLoading(false);
        }
    };



    return (
        <div className="bg-white">
            <Header />
            <div className="min-h-screen flex items-center justify-center">
                <div className="w-full max-w-md px-6 py-8">
                    <h1 className="text-2xl font-bold mb-8 text-center">회원가입</h1>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="이름"
                                maxLength={50}
                            />
                            {errors.name && <p className="mt-1 text-sm text-red-500">{errors.name}</p>}
                        </div>

                        <div>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500
              ${!enabledFields.email ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                placeholder="이메일"
                                disabled={!enabledFields.email}
                            />
                            {errors.email && <p className="mt-1 text-sm text-red-500">{errors.email}</p>}
                        </div>

                        <div>
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500
              ${!enabledFields.password ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                placeholder="비밀번호"
                                disabled={!enabledFields.password}
                            />
                            {errors.password && <p className="mt-1 text-sm text-red-500">{errors.password}</p>}
                        </div>

                        <div>
                            <input
                                type="password"
                                name="password2"
                                value={formData.password2}
                                onChange={handleChange}
                                className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500
              ${!enabledFields.password2 ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                placeholder="비밀번호 확인"
                                disabled={!enabledFields.password2}
                            />
                            {errors.password2 && (
                                <p className="mt-1 text-sm text-red-500">{errors.password2}</p>
                            )}
                        </div>

                        <div className="flex items-center space-x-2 mt-4">
                            <input
                                type="checkbox"
                                id="terms"
                                checked={agreedToTerms}
                                onChange={(e) => setAgreedToTerms(e.target.checked)}
                                className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                            />
                            <label htmlFor="terms" className="text-sm text-gray-600">
                                SWITCHUP <Link to="/terms" className="text-blue-600 hover:underline">이용약관</Link> 및{' '}
                                <Link to="/privacy" className="text-blue-600 hover:underline">개인정보처리방침</Link>에 동의합니다.
                            </label>
                        </div>

                        <button
                            type="submit"
                            className="w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-md transition duration-200 disabled:bg-gray-400 disabled:cursor-not-allowed"
                            disabled={
                                Object.values(errors).some(error => error !== '') ||
                                Object.values(formData).some(value => value === '') ||
                                !agreedToTerms ||
                                isLoading
                            }
                        >
                            {isLoading ? (
                                <div className="flex items-center justify-center">
                                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    처리중...
                                </div>
                            ) : '다음'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SignupEmail;